export default {
    USER_ID: `XHXhKYjGKUxOBGcT8`,
    TEMPLATE_ID: `template_sxbq0jj`,
    SERVICE_ID: `service_iv352gu`
    }